export function Close() {
	return (
		<svg
			width="25"
			height="25"
			viewBox="0 0 25 25"
			fill="white"
			xmlns="http://www.w3.org/2000/svg">
			<path d="M24.603 2.419L14.75 12.272L24.603 22.125L22.066 24.544L12.331 14.75L2.537 24.544L0 22.125L9.853 12.272L0 2.419L2.419 0L12.272 9.853L22.125 0L24.603 2.419Z" />
		</svg>
	);
}
